import {useCallback, useEffect, useRef, useState} from 'react';

import {getMedicationAdherenceApi} from 'redux/api/patientHome';
import {IMedicationAdherence} from 'redux/intervention/interfaces';

const REFRESH_MS = 30000;

// The patient's 7-day adherence per tracked medication. A failed load leaves `rows` empty (or as last
// loaded), so the Medications page simply hides the section instead of showing an error.
export function useMedicationAdherence() {
  const [rows, setRows] = useState<IMedicationAdherence[]>([]);
  const mountedRef = useRef(true);

  const load = useCallback(async () => {
    try {
      const response = await getMedicationAdherenceApi();

      if (mountedRef.current) {
        setRows(response.data.adherence ?? []);
      }
    } catch {
      // Keep what is on screen.
    }
  }, []);

  useEffect(() => {
    mountedRef.current = true;
    load();

    const interval = window.setInterval(load, REFRESH_MS);
    const onFocus = () => load();

    window.addEventListener('focus', onFocus);

    return () => {
      mountedRef.current = false;
      window.clearInterval(interval);
      window.removeEventListener('focus', onFocus);
    };
  }, [load]);

  return {rows, reload: load};
}
